export const SocialPlayerYoutubeViewerType =
  'wixui.SocialPlayerYoutube' as const;

// TODO: Update help id
export const helpIds = {
  settingsPanel: '???',
};

export const TestIds = {
  viewer: {
    iframe: 'SocialPlayerYoutube-iframe',
  },
};

export const translationKeys = {
  settingsPanel: {
    title: 'SocialPlayerYoutube.Settings_Title',
    urlLabel: 'SocialPlayerYoutube.Url_Label',
    urlPlaceholder: 'SocialPlayerYoutube.Url_Placeholder',
    autoPlayLabel: 'SocialPlayerYoutube.AutoPlay_Label',
    enabledControlsLabel: 'SocialPlayerYoutube.EnabledControls_Label',
    enabledCaptionsLabel: 'SocialPlayerYoutube.EnabledCaptions_Label',
    muteLabel: 'SocialPlayerYoutube.Mute_Label',
  },
  designPanel: {
    title: 'SocialPlayerYoutube_Design_Button_Header',
  },
} as const;
